import { Box, MenuItem, Select, Typography } from "@material-ui/core";

import { makeStyles } from "@material-ui/styles";
import { useField } from "react-final-form";
import useGeneralList from "../../../hooks/useGeneralList";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "150px auto",
    gridGap: 0,
    paddingRight: 50,
    boxSizing: "border-box",
    margin: "15px 0 15px 0",
  },
  textStyle: { marginTop: 13, fontSize: 16 },
  textField: {
    width: 300,
  },
  tierTextField: { width: 150 },
}));

const GeneralSelect = ({
  label,
  source,
  resource,
  require,
  isDouble,
  tierFilter = false, //Hardcode tier filter
}) => {
  const classes = useStyles();
  const [selectedData] = useState();
  const {
    input: { onChange, value },
    meta: { touched, error },
  } = useField(source);

  const handleSelect = (e) => {
    onChange(e.target.value);
  };
  return (
    <Box className={classes.container}>
      <Box style={{ display: "flex" }}>
        <Typography className={classes.textStyle}>{label}</Typography>
        {require ? (
          <Typography className={classes.textStyle} style={{ color: "orange" }}>
            *
          </Typography>
        ) : null}
      </Box>
      <Box className={isDouble ? classes.tierTextField : classes.textField}>
        <SelectData
          value={selectedData}
          onChange={handleSelect}
          defaultValue={value}
          resource={resource}
          error={error}
          touched={touched}
          tierFilter={tierFilter}
        />
      </Box>
    </Box>
  );
};

const SelectData = ({
  resource,
  value,
  defaultValue,
  onChange,
  error: dataError,
  touched,
  tierFilter, //Hardocde tier filter
}) => {
  const { datas, loading, error } = useGeneralList(resource);
  if (loading) return null;
  if (error) return null;
  let filteredDatas = datas;
  if (tierFilter) {
    filteredDatas = datas.filter(
      (data) => data.type !== "Reward" && data.type !== "Multiplier"
    ); //Bad code for filter out unwanted benefit
  }
  return (
    <Box>
      <Select
        defaultValue={defaultValue}
        onChange={onChange}
        value={value}
        fullWidth
      >
        {filteredDatas.map((data) => (
          <MenuItem value={data.id}>{data.name}</MenuItem>
        ))}
      </Select>
      {dataError && touched ? (
        <Typography style={{ color: "red" }} variant="caption">
          {dataError}
        </Typography>
      ) : null}
    </Box>
  );
};

export default GeneralSelect;
